import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Helper pra combinar classes do Tailwind sem conflito.
 *
 * cn('p-2', condition && 'p-4', 'text-red-500')
 * → mantém apenas 'p-4 text-red-500' (twMerge resolve conflitos de padding)
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
